/*
 * @Author: yejianfei
 * @Date: 2023-04-11 15:42:35
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-22 15:40:01
 * @Description:
 * @Developer:
 */
import React, { useEffect, useRef, useState } from 'react';
import { Input, Tag, theme } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
export default function InputTags(props) {
    const { token } = theme.useToken();
    const inputRef = useRef(null);
    const editRef = useRef(null);
    const [editing, setEditing] = useState(undefined);
    const [adding, setAdding] = useState(false);
    const [newValue, setNewValue] = useState('');
    const [editValue, setEditValue] = useState('');
    useEffect(() => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, [adding]);
    useEffect(() => { var _a; return (_a = editRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, [editing]);
    console.log('props', props.value, editing, adding);
    return (React.createElement(React.Fragment, null,
        (props.value || []).map((item, index) => (editing === index
            ? (React.createElement(Input, { ref: editRef, key: index, size: "small", style: {
                    width: 78,
                    verticalAlign: 'top',
                }, value: editValue, onChange: (event) => setEditValue(event.target.value), onBlur: () => setEditing(undefined), onPressEnter: () => {
                    const value = [...(props.value || [])];
                    value[editing] = editValue;
                    props.onChange && props.onChange(value);
                    setEditing(undefined);
                } }))
            : (React.createElement(Tag, { key: index, closable: true, children: item, style: { display: 'inline-block' }, onClose: () => {
                    console.log((props.value || []).filter((value) => value !== item));
                    props.onChange && props.onChange((props.value || []).filter((value) => value !== item));
                }, onDoubleClick: () => {
                    setEditValue(item);
                    setEditing(index);
                } })))),
        adding
            ?
                React.createElement(Input, { ref: inputRef, size: 'small', style: { width: 78, verticalAlign: 'top', }, value: newValue, onChange: (value) => setNewValue(value.target.value), onBlur: () => {
                        setAdding(false);
                        newValue && props.onChange && props.onChange([...(props.value || []), newValue]);
                    } })
            : (React.createElement(Tag, { onClick: () => {
                    setAdding(true);
                    setNewValue('');
                }, style: { background: token.colorBgContainer, borderStyle: 'dashed' } },
                React.createElement(PlusOutlined, null),
                " ",
                props.placeholder || '新增'))));
}
